import { defineComponent as _defineComponent } from 'vue'
import { isEmpty, isNil, uniqueId } from '@/utils/misc';
import { values } from '@/utils/enum';
import { AlertWorkflowStatus } from '@/models/alertWorkflow';
import { useI18n } from '@/composables/i18n';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertWorkflowStatusSelect',
  props: {
    value: null,
    disabledStatuses: { default: () => [] },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    hiddenLabel: { type: Boolean, default: false },
    hiddenDropdownIcon: { type: Boolean, default: false },
    isFontSizeSmall: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: AlertWorkflowStatus | AlertWorkflowStatus[]) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: AlertWorkflowStatus | AlertWorkflowStatus[], disabledStatuses: AlertWorkflowStatus[], multiple: boolean, disabled: boolean, hiddenLabel: boolean, hiddenDropdownIcon: boolean, isFontSizeSmall: boolean };





const { t } = useI18n();
const componentId = uniqueId();

function isStatusDisabled(status: AlertWorkflowStatus): boolean {
  return props.disabledStatuses.some((s) => s === status);
}

function isStatusActive(status: AlertWorkflowStatus): boolean {
  if (isNil(props.value)) {
    return false;
  }

  if (Array.isArray(props.value)) {
    return props.value.includes(status);
  }

  return props.value === status;
}

const valueOrDefault = computed(() =>
  isEmpty(props.value) ? undefined : props.value,
);

const multipleSelectionText = computed(() =>
  isEmpty(props.value)
    ? ''
    : t('e_service_center.alert_workflow_status_select.multiple_selected', {
        count: (props.value as AlertWorkflowStatus[]).length,
      }),
);

return { __sfc: true,props, emit, t, componentId, isStatusDisabled, isStatusActive, valueOrDefault, multipleSelectionText, isNil, values, AlertWorkflowStatus }
}

})